import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ErrorBoundary } from '@/components/ui/ErrorBoundary';
import { ErrorModal } from '@/components/ui/ErrorModal';
import { Toaster } from '@/components/ui/Toaster';
import { ProtectedLayout } from '@/views/layout/ProtectedLayout';
import { LoginPage } from '@/views/auth/LoginPage';
import { ClientsPage } from '@/views/clients/ClientsPage';
import { ClientCard } from '@/views/clients/ClientCard';
import { TariffsPage } from '@/views/tariffs/TariffsPage';
import { ReportsPage } from '@/views/reports/ReportsPage';
import { NewClientsReportPage } from '@/views/reports/NewClientsReportPage';
import { FinancesReportPage } from '@/views/reports/FinancesReportPage';
import { AuthorPage } from '@/views/author/AuthorPage';
import { NotFoundPage } from '@/views/NotFoundPage';

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ErrorModal />
        <Toaster />
        <Routes>
          <Route path='/' element={<Navigate to='/clients' replace />} />
          <Route path='/login' element={<LoginPage />} />
          <Route element={<ProtectedLayout />}>
            <Route path='/clients' element={<ClientsPage />} />
            <Route path='/clients/:id' element={<ClientCard />} />
            <Route path='/tariffs' element={<TariffsPage />} />
            <Route path='/reports' element={<ReportsPage />} />
            <Route path='/reports/new-clients' element={<NewClientsReportPage />} />
            <Route path='/reports/finances' element={<FinancesReportPage />} />
          </Route>
          <Route path='/~' element={<AuthorPage />} />
          <Route path='/404' element={<NotFoundPage />} />
          <Route path='*' element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
